module.exports = __webpack_public_path__ + "img/ventanilla.18911d9b.png";